import { HOT_TOPICS } from '@/mocks/entertainment';

interface HeroProps {
  onTopic: (label: string) => void;
}

export default function Hero({ onTopic }: HeroProps) {
  const handle = (label: string) => {
    onTopic(label);
    document.getElementById('feed')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="top"
      className="relative overflow-hidden bg-gradient-to-br from-primary-500 via-primary-600 to-primary-800"
    >
      {/* decorative shapes */}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-accent-500/30 blur-3xl"></div>
        <div className="absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-secondary-500/30 blur-3xl"></div>
        <span className="absolute right-[6%] top-[16%] hidden md:block rotate-12 rounded-2xl border border-background-50/20 bg-background-50/10 px-4 py-2 text-2xl font-heading font-bold text-background-50/80">
          吃瓜中
        </span>
        <span className="absolute left-[52%] top-[58%] hidden lg:block -rotate-6 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50/90">
          # 谁能上榜就看热度
        </span>
      </div>

      <div className="relative mx-auto flex min-h-[560px] md:min-h-[640px] w-full flex-col justify-center px-4 pb-14 pt-32 md:px-6 lg:px-10 md:pt-36">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-3.5 py-1.5">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary-300 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-secondary-300"></span>
            </span>
            <span className="font-label text-xs md:text-sm tracking-wide text-background-50">
              娱乐风向标 · 每天 30+ 条新瓜入库
            </span>
          </div>

          <h1 className="mt-6 font-heading text-3xl font-extrabold leading-tight tracking-tight text-background-50 md:text-5xl md:leading-[1.1]">
            今天，谁在风口浪尖？
            <br />
            <span className="text-secondary-300">吃瓜八卦</span>带你一网打尽
          </h1>

          <p className="mt-5 max-w-xl text-sm md:text-base leading-relaxed text-background-100/85">
            从演员到歌手、从爱豆到幕后，最新动态、热门爆料与幕后故事都在这里汇合。谁有瓜、谁在上升，点进来立刻就能看清圈内风向。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#feed"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-transform hover:-translate-y-0.5"
            >
              马上开瓜 <i className="ri-arrow-right-line ml-1.5"></i>
            </a>
            <a
              href="#rank"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              围观每周人气榜
            </a>
          </div>
        </div>

        {/* hot topics */}
        <div className="mt-12 max-w-4xl">
          <p className="font-label text-xs tracking-widest text-background-100/70">
            今日话题正在发酵，点一下直达热瓜：
          </p>
          <div className="mt-3 flex flex-wrap gap-2.5">
            {HOT_TOPICS.map((t) => (
              <button
                key={t.id}
                type="button"
                onClick={() => handle(t.label)}
                className="group flex items-center gap-2.5 rounded-2xl border border-background-50/20 bg-background-50/10 px-4 py-2.5 text-left backdrop-blur-sm transition-colors hover:bg-background-50/20"
              >
                <i className="ri-flashlight-fill text-secondary-300"></i>
                <span className="flex flex-col leading-tight">
                  <span className="text-sm font-semibold text-background-50">{t.label}</span>
                  <span className="font-label text-[11px] text-background-100/70">{t.count}</span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* bottom wave-ish strip */}
      <div className="relative h-2 bg-gradient-to-r from-secondary-500 via-accent-500 to-primary-900"></div>
    </section>
  );
}